module.exports = __webpack_public_path__ + "static/media/7.Star PNG 1.ff29f503.gif";